<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<chart v-if="chartData" type="bar" :data="chartData" height="375"></chart>
		</menu-aside>
	</app>
</template>

<script>
	import chart from '@/components/charts/index.vue'
	
	export default {
		components: {
			chart
		},
		
		data() {
			return {
				chartData: ''
			}
		},
		
		mounted() {
			this.request({
				url: '/workbench/flow_chart_data',
				success: data => {
					this.chartData = [{
						type: '有效保函数',
						data: Array.from(data, item => {
							return {
								name: item.title,
								value: item.yxCount
							}
						})
					}, {
						type: '生效保函数',
						data: Array.from(data, item => {
							return {
								name: item.title,
								value: item.sxzCount
							}
						})
					}];
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
</style>
